import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getAuth, logout } from "../../services/AuthService";
import Link from "../../common/Link";


export default function LogoutPage() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search)
  const redirect: string | null = params.get('redirect');
  const logoutRedirect = redirect ?? '/';
  const auth = getAuth();

  useEffect(() => {
    if (auth !== null) {
      (async() => {
        await logout();
        navigate(logoutRedirect);
      })();
    }
  }, [auth, navigate, logoutRedirect]);

  return auth !== null ? <>
    <h2>Logout...</h2>
    <span>
      Se la pagina non reindirizza entro qualche secondo per favore{' '}
      <Link href={logoutRedirect}>
        clicca qui
      </Link> per continuare.
    </span>
  </> : <p>
    <h4>Attenzione:</h4>
    Stai cercando di effettuare il logout senza essere loggato.
    <br /><br />
    Forse stavi cercando di effettuare il <Link href="/accedi">login</Link>.
  </p>;
}
